import { Divider, Popover } from 'antd'
import './index.less'

const Footer = () => {
  return (
    <div className="footer">
      <div className="menu">
        <a href="https://www.sisyphe.com.cn/" target="_blank" rel="noreferrer">
          关于我们
        </a>
        <Divider type="vertical" />
        <Popover
          content={<img width={150} src={require('./qrq.png')} alt="" />}
        >
          <a
            href="https://www.sisyphe.cn/"
            target="_blank"
            rel="noreferrer"
            style={{ cursor: 'pointer' }}
          >
            西西弗APP
          </a>
        </Popover>
      </div>
      <div className="concat">商务合作：023-65316297</div>
      <div className="police">
        <span>渝ICP备200001350号-1</span>
        <img src={require('./police.png')} alt="渝ICP备200001350号-1" />
        <span>渝公网安备</span>
        <span>50010302002809号</span>
      </div>
    </div>
  )
}

export default Footer
